import Link from "next/link";
import type { ReactNode } from "react";

type Variant = "primary" | "navy" | "ghost" | "white";

const base =
  "inline-flex items-center justify-center gap-2 rounded-lg px-6 py-3 text-[0.95rem] font-semibold transition-all focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-emerald";

const variants: Record<Variant, string> = {
  primary: "bg-emerald text-white shadow-[0_8px_20px_-8px_rgba(27,163,123,0.7)] hover:bg-emerald-deep hover:shadow-[0_10px_24px_-8px_rgba(27,163,123,0.8)]",
  navy: "bg-ink text-white hover:bg-ink-2",
  ghost: "border border-line-2 text-ink hover:border-ink hover:bg-mist",
  white: "bg-white text-ink hover:bg-mist",
};

export function Button({
  href,
  children,
  variant = "primary",
  className = "",
  trackClick,
}: {
  href: string;
  children: ReactNode;
  variant?: Variant;
  className?: string;
  /** Fires this PostHog event on click (handled by FunnelTracking's click delegation). */
  trackClick?: string;
}) {
  return (
    <Link
      href={href}
      className={`${base} ${variants[variant]} ${className}`}
      {...(trackClick ? { "data-track-click": trackClick } : {})}
    >
      {children}
    </Link>
  );
}
